import { ActionReducerMap } from '@ngrx/store';
import * as fromUserProfile from './user-profile';
export interface CoreModuleState {
  userProfile: fromUserProfile.State;
}

export const reducers: ActionReducerMap<CoreModuleState> = {
  userProfile: fromUserProfile.reducer
};
